<template>
  <div
    class="panel --is-catalog catalog level-catalog"
    :class="{ '--wider-list-items': $store.getters.getCurrentLevel === 1 }"
  >
    <FilterCatalogLevel1 v-if="$store.getters.getCurrentLevel === 1" />
    <FilterCatalogLevel3 v-if="$store.getters.getCurrentLevel === 3" />

    <Alert
      type="info"
      v-if="
        $store.getters.getCurrentLevel === 3 &&
          $store.getters.getLevel3Available &&
          !$store.getters.getLevel3NotAvailable
      "
      >Nur noch wenig Platz für weitere Köstlichkeiten</Alert
    >
    <Alert
      type="warning"
      v-else-if="
        $store.getters.getCurrentLevel === 3 &&
          $store.getters.getLevel3Available &&
          $store.getters.getLevel3NotAvailable
      "
      >Leider kein Platz für weitere Köstlichkeiten</Alert
    >

    <ul
      v-if="listItems.length === 0 && $store.getters.getCountLoading > 0"
      class="level-catalog__list"
    >
      <li>
        <CatalogItemPlaceholder type="level" />
      </li>
      <li>
        <CatalogItemPlaceholder type="level" />
      </li>
      <li>
        <CatalogItemPlaceholder type="level" />
      </li>
      <li>
        <CatalogItemPlaceholder type="level" />
      </li>
      <li>
        <CatalogItemPlaceholder type="level" />
      </li>
      <li>
        <CatalogItemPlaceholder type="level" />
      </li>
    </ul>
    <div
      v-if="listItems.length === 0 && $store.getters.getCountLoading === 0"
      class="level-catalog__empty"
    >
      Es konnten leider keine Geschenke gefunden werden, die den Suchkriterien entsprechen.
    </div>
    <ul v-else class="level-catalog__list" ref="catalogList">
      <li v-for="item in listItems" :key="item.id">
        <ProductCard :item="item" />
      </li>
    </ul>

    <slot v-if="$store.getters.isB2b && $store.getters.getCurrentLevel === 1 && $store.getters.getExtraLevel1.length > 0">
      <strong>Weitere Präsente, die für Sie relevant sein könnten:</strong>
      <ul class="level-catalog__list" ref="catalogList">
        <li v-for="item in $store.getters.getExtraLevel1" :key="item.id">
          <ProductCard :item="item"/>
        </li>
      </ul>
    </slot>

    <transition name="scroll-top-transition">
      <div v-if="isScrolled" class="level-catalog__scroll-up">
        <button @click="scrollTo('header')" title="nach oben scrollen"><i class="icon-angle-up"></i></button>
      </div>
    </transition>
  </div>
</template>

<script>
import { UiMixin } from '@/mixins/UiMixin';

import ProductCard from '@/components/Configurator/ProductCard';
import CatalogItemPlaceholder from '@/components/CatalogItemPlaceholder';
import Alert from '@/components/Alert';
import FilterCatalogLevel1 from '@/components/FilterCatalogLevel1';
import FilterCatalogLevel3 from '@/components/FilterCatalogLevel3';

export default {
  name: 'LevelCatalog',
  mixins: [UiMixin],
  props: ['listItems'],
  components: {
    Alert,
    ProductCard,
    CatalogItemPlaceholder,
    FilterCatalogLevel1,
    FilterCatalogLevel3
  },
  data () {
    return {
      isScrolled: false
    };
  },
  methods: {
    checkScroll () {
      if (window.scrollY > window.innerHeight) {
        this.isScrolled = true;
      } else {
        this.isScrolled = false;
      }
    }
  },
  mounted () {
    document.addEventListener('scroll', this.checkScroll);
  },
  destroyed () {
    document.removeEventListener('scroll', this.checkScroll);
  }
};
</script>

<style lang="scss">
@import '../assets/styles/components/level-catalog';
</style>
